export const GET_GROUPS_BY_COMPANY_QUERY = `
  query GetGroupsByCompany($companyId: Int!) {
    groups(where: { company_id: { _eq: $companyId } }, order_by: { created_at: desc }) {
      id
      name
      description
      company_id
      group_manager_id
      created_at
      updated_at
      company {
        id
        name
      }
      user {
        id
        first_name
        last_name
        role
      }
      teams {
        id
        name
      }
      group_tags {
        id
        tag_id
        tag {
          id
          name
          tags_color
          tags_page
        }
      }
    }
  }
`;

export const GET_ALL_GROUPS_QUERY = `
  query GetAllGroups($where: groups_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [groups_order_by!] = [{ created_at: desc }]) {
    groups_aggregate(where: $where) {
      aggregate { count }
    }
    groups(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      name
      description
      company_id
      group_manager_id
      created_at
      updated_at
      company {
        id
        name
      }
      user {
        id
        first_name
        last_name
        role
      }
      teams {
        id
        name
      }
      group_tags {
        id
        tag_id
        tag {
          id
          name
          tags_color
          tags_page
        }
      }
    }
  }
`;

export const GET_GROUPS_FOR_FORM_QUERY = `
  query GetGroupsForForm($where: groups_bool_exp) {
    groups(where: $where) {
      id
      name
      group_manager_id
      group_tags {
        id
        tag_id
        tag {
          id
          name
          tags_color
          tags_page
        }
      }
      teams {
        id
        name
        group_id
      }
    }
  }
`;

export const GET_ALL_GROUPS_FOR_FORM_QUERY = `
  query GetAllGroupsForForm {
    groups {
      id
      name
      group_manager_id
      group_tags {
        id
        tag_id
        tag {
          id
          name
          tags_color
          tags_page
        }
      }
      teams {
        id
        name
        group_id
      }
    }
  }
`; 